import React from 'react';
import { Box, Text } from '@chakra-ui/react';
export var PaymentMethodContainer = function PaymentMethodContainer(props) {
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      border: '1px solid',
      borderColor: 'gray.200',
      borderRadius: '8px',
      p: '6'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    sx: {
      fontWeight: 'bold',
      fontSize: '20px',
      mb: 4
    }
  }, "\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19"), props.children);
};